<template>
	<ValidationProvider
		ref="provider"
		:name="options.label"
		:rules="options.rules"
		v-slot="{ errors, classes }"
		slim
		v-if="isVisible"
		:class="options.inputClass"
        :vid="`${computedName}-${generatedId}`"
	>
		<label class="select-label d-table w-100 text-center" v-if="options.sidebar">{{ options.label }}</label>
		<div :class="[options.wrapperClass, { 'mb-8px': errors[0] === undefined }]">
			<span class="select-label d-table w-100 mb-10px" v-if="options.guide">{{ options.guide }}</span>
			<span :class="[...computedClasses(classes), { hasValue: !classes.touched && hasValue }]">
				<select
					:name="name"
					:class="options.className"
					:id="generatedId"
					:value="getData()"
					@change="onChange($event)"
					:disabled="isDisabled"
					data-hj-allow
				>
					<option v-if="!options.sidebar" :value="null" disabled selected>{{ options.label }}</option>
					<option v-for="(choice, index) in computedChoices" :key="index" :value="choice.value">
						{{ choice.text }}
					</option>
				</select>
			</span>
			<span
				:class="['error_message error_message--broke', options.className, { 'mb-8px': type === 'contracting' }]"
				v-if="errors[0]"
			>
				{{ errors[0] }}
			</span>
		</div>
	</ValidationProvider>
</template>

<script>
import shared from '@/mixins/shared';
import _, { each } from 'lodash';
import { mapGetters } from 'vuex';

export default {
	mixins: [shared],
	computed: {
		...mapGetters('contracting', ['getDisabledInputs']),
		computedClasses() {
			return classes => {
				return _.has(this.options, 'novalidate')
					? ['w-100 select-arrow', this.options.className]
					: ['w-100 select-arrow', this.options.className, classes];
			};
		},
		computedChoices() {
			const choices = [];

			each(this.options.choices, (text, value) => {
				choices.push({ value, text });
			});

			if (this.name === 'roof_type') {
				choices.splice(1, 0, { value: 5, text: this.options.choices[5] });
				choices.splice(6, 1);
			}

			if (this.name === 'floor' && this.type === 'calculation') {
				for (let i = 1; i <= 30; i++) {
					choices.push({ value: i, text: i });
				}
			}

			return choices;
		},
		isDisabled() {
			if (this.type === 'contracting') {
				return this.getDisabledInputs.includes(
					`${this.options.input.parent}-${this.options.input.group}-${this.options.input.prop}`,
				);
			}
		},
	},
	methods: {
		makeNotifierErrors() {
			if (this.name === 'wall_type') {
				if (this.$parent.$parent.$refs.notify_wall_type !== undefined) {
					this.$parent.$parent.$refs.notify_wall_type[0].$refs.component.makeErrors();
				}
			}
		},
	},
};
</script>
